/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AnalyticsBreakdownDto } from '../models/analytics-breakdown-dto';
import { AnalyticsFunnelDto } from '../models/analytics-funnel-dto';
import { AnalyticsSummaryDto } from '../models/analytics-summary-dto';
import { AnalyticsTimeseriesDto } from '../models/analytics-timeseries-dto';
import { GlobalStatsDto } from '../models/global-stats-dto';
import { PaginatedUsersDto } from '../models/paginated-users-dto';
import { SessionDto } from '../models/session-dto';
import { superadminControllerDeleteViastoriaIntegration } from '../fn/superadmin/superadmin-controller-delete-viastoria-integration';
import { SuperadminControllerDeleteViastoriaIntegration$Params } from '../fn/superadmin/superadmin-controller-delete-viastoria-integration';
import { superadminControllerGetAnalyticsBreakdown } from '../fn/superadmin/superadmin-controller-get-analytics-breakdown';
import { SuperadminControllerGetAnalyticsBreakdown$Params } from '../fn/superadmin/superadmin-controller-get-analytics-breakdown';
import { superadminControllerGetAnalyticsFunnel } from '../fn/superadmin/superadmin-controller-get-analytics-funnel';
import { SuperadminControllerGetAnalyticsFunnel$Params } from '../fn/superadmin/superadmin-controller-get-analytics-funnel';
import { superadminControllerGetAnalyticsSummary } from '../fn/superadmin/superadmin-controller-get-analytics-summary';
import { SuperadminControllerGetAnalyticsSummary$Params } from '../fn/superadmin/superadmin-controller-get-analytics-summary';
import { superadminControllerGetAnalyticsTimeseries } from '../fn/superadmin/superadmin-controller-get-analytics-timeseries';
import { SuperadminControllerGetAnalyticsTimeseries$Params } from '../fn/superadmin/superadmin-controller-get-analytics-timeseries';
import { superadminControllerGetGlobalStats } from '../fn/superadmin/superadmin-controller-get-global-stats';
import { SuperadminControllerGetGlobalStats$Params } from '../fn/superadmin/superadmin-controller-get-global-stats';
import { superadminControllerGetUser } from '../fn/superadmin/superadmin-controller-get-user';
import { SuperadminControllerGetUser$Params } from '../fn/superadmin/superadmin-controller-get-user';
import { superadminControllerGetUserIntegrations } from '../fn/superadmin/superadmin-controller-get-user-integrations';
import { SuperadminControllerGetUserIntegrations$Params } from '../fn/superadmin/superadmin-controller-get-user-integrations';
import { superadminControllerGetUserStats } from '../fn/superadmin/superadmin-controller-get-user-stats';
import { SuperadminControllerGetUserStats$Params } from '../fn/superadmin/superadmin-controller-get-user-stats';
import { superadminControllerImpersonate } from '../fn/superadmin/superadmin-controller-impersonate';
import { SuperadminControllerImpersonate$Params } from '../fn/superadmin/superadmin-controller-impersonate';
import { superadminControllerListTags } from '../fn/superadmin/superadmin-controller-list-tags';
import { SuperadminControllerListTags$Params } from '../fn/superadmin/superadmin-controller-list-tags';
import { superadminControllerListUsers } from '../fn/superadmin/superadmin-controller-list-users';
import { SuperadminControllerListUsers$Params } from '../fn/superadmin/superadmin-controller-list-users';
import { superadminControllerUpdateSubscription } from '../fn/superadmin/superadmin-controller-update-subscription';
import { SuperadminControllerUpdateSubscription$Params } from '../fn/superadmin/superadmin-controller-update-subscription';
import { superadminControllerUpdateTags } from '../fn/superadmin/superadmin-controller-update-tags';
import { SuperadminControllerUpdateTags$Params } from '../fn/superadmin/superadmin-controller-update-tags';
import { superadminControllerUpsertViastoriaIntegration } from '../fn/superadmin/superadmin-controller-upsert-viastoria-integration';
import { SuperadminControllerUpsertViastoriaIntegration$Params } from '../fn/superadmin/superadmin-controller-upsert-viastoria-integration';
import { SuperadminIntegrationDto } from '../models/superadmin-integration-dto';
import { SuperadminUserDto } from '../models/superadmin-user-dto';
import { UserStatsDto } from '../models/user-stats-dto';

@Injectable({ providedIn: 'root' })
export class SuperadminService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `superadminControllerGetGlobalStats()` */
  static readonly SuperadminControllerGetGlobalStatsPath = '/superadmin/stats';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `superadminControllerGetGlobalStats()` instead.
   *
   * This method doesn't expect any request body.
   */
  superadminControllerGetGlobalStats$Response(params?: SuperadminControllerGetGlobalStats$Params, context?: HttpContext): Observable<StrictHttpResponse<GlobalStatsDto>> {
    return superadminControllerGetGlobalStats(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `superadminControllerGetGlobalStats$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  superadminControllerGetGlobalStats(params?: SuperadminControllerGetGlobalStats$Params, context?: HttpContext): Observable<GlobalStatsDto> {
    return this.superadminControllerGetGlobalStats$Response(params, context).pipe(
      map((r: StrictHttpResponse<GlobalStatsDto>): GlobalStatsDto => r.body)
    );
  }

  /** Path part for operation `superadminControllerListUsers()` */
  static readonly SuperadminControllerListUsersPath = '/superadmin/users';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `superadminControllerListUsers()` instead.
   *
   * This method doesn't expect any request body.
   */
  superadminControllerListUsers$Response(params?: SuperadminControllerListUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedUsersDto>> {
    return superadminControllerListUsers(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `superadminControllerListUsers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  superadminControllerListUsers(params?: SuperadminControllerListUsers$Params, context?: HttpContext): Observable<PaginatedUsersDto> {
    return this.superadminControllerListUsers$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaginatedUsersDto>): PaginatedUsersDto => r.body)
    );
  }

  /** Path part for operation `superadminControllerListTags()` */
  static readonly SuperadminControllerListTagsPath = '/superadmin/tags';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `superadminControllerListTags()` instead.
   *
   * This method doesn't expect any request body.
   */
  superadminControllerListTags$Response(params?: SuperadminControllerListTags$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return superadminControllerListTags(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `superadminControllerListTags$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  superadminControllerListTags(params?: SuperadminControllerListTags$Params, context?: HttpContext): Observable<Array<string>> {
    return this.superadminControllerListTags$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /** Path part for operation `superadminControllerGetUser()` */
  static readonly SuperadminControllerGetUserPath = '/superadmin/users/{uuid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `superadminControllerGetUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  superadminControllerGetUser$Response(params: SuperadminControllerGetUser$Params, context?: HttpContext): Observable<StrictHttpResponse<SuperadminUserDto>> {
    return superadminControllerGetUser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `superadminControllerGetUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  superadminControllerGetUser(params: SuperadminControllerGetUser$Params, context?: HttpContext): Observable<SuperadminUserDto> {
    return this.superadminControllerGetUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<SuperadminUserDto>): SuperadminUserDto => r.body)
    );
  }

  /** Path part for operation `superadminControllerGetUserStats()` */
  static readonly SuperadminControllerGetUserStatsPath = '/superadmin/users/{uuid}/stats';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `superadminControllerGetUserStats()` instead.
   *
   * This method doesn't expect any request body.
   */
  superadminControllerGetUserStats$Response(params: SuperadminControllerGetUserStats$Params, context?: HttpContext): Observable<StrictHttpResponse<UserStatsDto>> {
    return superadminControllerGetUserStats(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `superadminControllerGetUserStats$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  superadminControllerGetUserStats(params: SuperadminControllerGetUserStats$Params, context?: HttpContext): Observable<UserStatsDto> {
    return this.superadminControllerGetUserStats$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserStatsDto>): UserStatsDto => r.body)
    );
  }

  /** Path part for operation `superadminControllerUpdateTags()` */
  static readonly SuperadminControllerUpdateTagsPath = '/superadmin/users/{uuid}/tags';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `superadminControllerUpdateTags()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  superadminControllerUpdateTags$Response(params: SuperadminControllerUpdateTags$Params, context?: HttpContext): Observable<StrictHttpResponse<SuperadminUserDto>> {
    return superadminControllerUpdateTags(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `superadminControllerUpdateTags$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  superadminControllerUpdateTags(params: SuperadminControllerUpdateTags$Params, context?: HttpContext): Observable<SuperadminUserDto> {
    return this.superadminControllerUpdateTags$Response(params, context).pipe(
      map((r: StrictHttpResponse<SuperadminUserDto>): SuperadminUserDto => r.body)
    );
  }

  /** Path part for operation `superadminControllerUpdateSubscription()` */
  static readonly SuperadminControllerUpdateSubscriptionPath = '/superadmin/users/{uuid}/subscription';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `superadminControllerUpdateSubscription()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  superadminControllerUpdateSubscription$Response(params: SuperadminControllerUpdateSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<SuperadminUserDto>> {
    return superadminControllerUpdateSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `superadminControllerUpdateSubscription$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  superadminControllerUpdateSubscription(params: SuperadminControllerUpdateSubscription$Params, context?: HttpContext): Observable<SuperadminUserDto> {
    return this.superadminControllerUpdateSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<SuperadminUserDto>): SuperadminUserDto => r.body)
    );
  }

  /** Path part for operation `superadminControllerImpersonate()` */
  static readonly SuperadminControllerImpersonatePath = '/superadmin/users/{uuid}/impersonate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `superadminControllerImpersonate()` instead.
   *
   * This method doesn't expect any request body.
   */
  superadminControllerImpersonate$Response(params: SuperadminControllerImpersonate$Params, context?: HttpContext): Observable<StrictHttpResponse<SessionDto>> {
    return superadminControllerImpersonate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `superadminControllerImpersonate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  superadminControllerImpersonate(params: SuperadminControllerImpersonate$Params, context?: HttpContext): Observable<SessionDto> {
    return this.superadminControllerImpersonate$Response(params, context).pipe(
      map((r: StrictHttpResponse<SessionDto>): SessionDto => r.body)
    );
  }

  /** Path part for operation `superadminControllerGetUserIntegrations()` */
  static readonly SuperadminControllerGetUserIntegrationsPath = '/superadmin/users/{uuid}/integrations';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `superadminControllerGetUserIntegrations()` instead.
   *
   * This method doesn't expect any request body.
   */
  superadminControllerGetUserIntegrations$Response(params: SuperadminControllerGetUserIntegrations$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SuperadminIntegrationDto>>> {
    return superadminControllerGetUserIntegrations(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `superadminControllerGetUserIntegrations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  superadminControllerGetUserIntegrations(params: SuperadminControllerGetUserIntegrations$Params, context?: HttpContext): Observable<Array<SuperadminIntegrationDto>> {
    return this.superadminControllerGetUserIntegrations$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SuperadminIntegrationDto>>): Array<SuperadminIntegrationDto> => r.body)
    );
  }

  /** Path part for operation `superadminControllerUpsertViastoriaIntegration()` */
  static readonly SuperadminControllerUpsertViastoriaIntegrationPath = '/superadmin/users/{uuid}/integrations/viastoria';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `superadminControllerUpsertViastoriaIntegration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  superadminControllerUpsertViastoriaIntegration$Response(params: SuperadminControllerUpsertViastoriaIntegration$Params, context?: HttpContext): Observable<StrictHttpResponse<SuperadminIntegrationDto>> {
    return superadminControllerUpsertViastoriaIntegration(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `superadminControllerUpsertViastoriaIntegration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  superadminControllerUpsertViastoriaIntegration(params: SuperadminControllerUpsertViastoriaIntegration$Params, context?: HttpContext): Observable<SuperadminIntegrationDto> {
    return this.superadminControllerUpsertViastoriaIntegration$Response(params, context).pipe(
      map((r: StrictHttpResponse<SuperadminIntegrationDto>): SuperadminIntegrationDto => r.body)
    );
  }

  /** Path part for operation `superadminControllerDeleteViastoriaIntegration()` */
  static readonly SuperadminControllerDeleteViastoriaIntegrationPath = '/superadmin/users/{uuid}/integrations/viastoria';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `superadminControllerDeleteViastoriaIntegration()` instead.
   *
   * This method doesn't expect any request body.
   */
  superadminControllerDeleteViastoriaIntegration$Response(params: SuperadminControllerDeleteViastoriaIntegration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return superadminControllerDeleteViastoriaIntegration(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `superadminControllerDeleteViastoriaIntegration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  superadminControllerDeleteViastoriaIntegration(params: SuperadminControllerDeleteViastoriaIntegration$Params, context?: HttpContext): Observable<void> {
    return this.superadminControllerDeleteViastoriaIntegration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `superadminControllerGetAnalyticsSummary()` */
  static readonly SuperadminControllerGetAnalyticsSummaryPath = '/superadmin/analytics/summary';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `superadminControllerGetAnalyticsSummary()` instead.
   *
   * This method doesn't expect any request body.
   */
  superadminControllerGetAnalyticsSummary$Response(params?: SuperadminControllerGetAnalyticsSummary$Params, context?: HttpContext): Observable<StrictHttpResponse<AnalyticsSummaryDto>> {
    return superadminControllerGetAnalyticsSummary(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `superadminControllerGetAnalyticsSummary$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  superadminControllerGetAnalyticsSummary(params?: SuperadminControllerGetAnalyticsSummary$Params, context?: HttpContext): Observable<AnalyticsSummaryDto> {
    return this.superadminControllerGetAnalyticsSummary$Response(params, context).pipe(
      map((r: StrictHttpResponse<AnalyticsSummaryDto>): AnalyticsSummaryDto => r.body)
    );
  }

  /** Path part for operation `superadminControllerGetAnalyticsTimeseries()` */
  static readonly SuperadminControllerGetAnalyticsTimeseriesPath = '/superadmin/analytics/timeseries';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `superadminControllerGetAnalyticsTimeseries()` instead.
   *
   * This method doesn't expect any request body.
   */
  superadminControllerGetAnalyticsTimeseries$Response(params?: SuperadminControllerGetAnalyticsTimeseries$Params, context?: HttpContext): Observable<StrictHttpResponse<AnalyticsTimeseriesDto>> {
    return superadminControllerGetAnalyticsTimeseries(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `superadminControllerGetAnalyticsTimeseries$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  superadminControllerGetAnalyticsTimeseries(params?: SuperadminControllerGetAnalyticsTimeseries$Params, context?: HttpContext): Observable<AnalyticsTimeseriesDto> {
    return this.superadminControllerGetAnalyticsTimeseries$Response(params, context).pipe(
      map((r: StrictHttpResponse<AnalyticsTimeseriesDto>): AnalyticsTimeseriesDto => r.body)
    );
  }

  /** Path part for operation `superadminControllerGetAnalyticsFunnel()` */
  static readonly SuperadminControllerGetAnalyticsFunnelPath = '/superadmin/analytics/funnel';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `superadminControllerGetAnalyticsFunnel()` instead.
   *
   * This method doesn't expect any request body.
   */
  superadminControllerGetAnalyticsFunnel$Response(params?: SuperadminControllerGetAnalyticsFunnel$Params, context?: HttpContext): Observable<StrictHttpResponse<AnalyticsFunnelDto>> {
    return superadminControllerGetAnalyticsFunnel(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `superadminControllerGetAnalyticsFunnel$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  superadminControllerGetAnalyticsFunnel(params?: SuperadminControllerGetAnalyticsFunnel$Params, context?: HttpContext): Observable<AnalyticsFunnelDto> {
    return this.superadminControllerGetAnalyticsFunnel$Response(params, context).pipe(
      map((r: StrictHttpResponse<AnalyticsFunnelDto>): AnalyticsFunnelDto => r.body)
    );
  }

  /** Path part for operation `superadminControllerGetAnalyticsBreakdown()` */
  static readonly SuperadminControllerGetAnalyticsBreakdownPath = '/superadmin/analytics/breakdown';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `superadminControllerGetAnalyticsBreakdown()` instead.
   *
   * This method doesn't expect any request body.
   */
  superadminControllerGetAnalyticsBreakdown$Response(params?: SuperadminControllerGetAnalyticsBreakdown$Params, context?: HttpContext): Observable<StrictHttpResponse<AnalyticsBreakdownDto>> {
    return superadminControllerGetAnalyticsBreakdown(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `superadminControllerGetAnalyticsBreakdown$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  superadminControllerGetAnalyticsBreakdown(params?: SuperadminControllerGetAnalyticsBreakdown$Params, context?: HttpContext): Observable<AnalyticsBreakdownDto> {
    return this.superadminControllerGetAnalyticsBreakdown$Response(params, context).pipe(
      map((r: StrictHttpResponse<AnalyticsBreakdownDto>): AnalyticsBreakdownDto => r.body)
    );
  }

}
